export default () => ({
  root: {
    padding: 20,
    width: "100%",
    minHeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
});
